<template>
  <div>
    <div class="headerMobile"><headerIndex @changeIndex="handleChangeIndex"></headerIndex></div>
    <div class="carousel slide">
      <el-carousel class="carousel-inner" height="430px">
        <el-carousel-item
          v-for="(s, index) in slide"
          :key="index"
          :name="String(index)"
          class="carousel-item active"
        >
          <a :href="s.url">
            <img :src="s.cover" class="d-block w-100" alt="..." />
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="top topHidden">
      <a href="/">
        <img class="logo" alt="logo" src="../assets/img/logo.png" />
      </a>
      <!-- <nav class="my-2 my-md-0 mr-md-3 clearfix" style="float: right">
        <div class="search">
          <div>
            <input type="text" placeholder="" required />
          </div>
        </div>
      </nav> -->
    </div>
    <div
      class="container-fluid navHidden"
      style="
        margin: 0 !important;
        border-bottom: #e9e9e9 1px solid;
        height: 103px;
        margin-bottom: 20px !important;
      "
    >
      <div class="row row-cols-5">
        <div class="col" @click="handleClick(0)">
          <div
            :class="[
              { menuCur: this.activeIndex === 0 },
              'items',
              'text-center',
              'menuLine',
            ]"
          >
            <img class="img-responsive" src="../assets/img/menu1.png" /><a
              href="#"
              >国际范式与研究方法</a
            >
          </div>
        </div>
        <div class="col" @click="handleClick(1)">
          <div
            :class="[
              { menuCur: this.activeIndex === 1 },
              'items',
              'text-center',
              'menuLine',
            ]"
          >
            <img class="img-responsive" src="../assets/img/menu2.png" /><a
              href="#"
              >学术前沿与经典理论</a
            >
          </div>
        </div>
        <div class="col" @click="handleClick(2)">
          <div
            :class="[
              { menuCur: this.activeIndex === 2 },
              'items',
              'text-center',
              'menuLine',
            ]"
          >
            <img class="img-responsive" src="../assets/img/menu3.png" /><a
              href="#"
              >选题与科研立项</a
            >
          </div>
        </div>
        <div class="col" @click="handleClick(3)">
          <div
            :class="[
              { menuCur: this.activeIndex === 3 },
              'items',
              'text-center',
              'menuLine',
            ]"
          >
            <img class="img-responsive" src="../assets/img/menu4.png" /><a
              href="#"
              >学术写作与出版</a
            >
          </div>
        </div>
        <div class="col" @click="handleClick(4)">
          <div
            :class="[
              { menuCur: this.activeIndex === 4 },
              'items',
              'text-center',
              'menuLine',
            ]"
          >
            <img class="img-responsive" src="../assets/img/menu5.png" />
            <a href="#"> 图书资源</a>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-if="this.activeIndex !== 4">
      <div class="row">
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-xs-12 cList"
          v-for="book in this.books"
          :key="book._id"
        >
          <router-link
            :to="'/course/' + book._id + '?tags=' + Tagtext[activeIndex]"
          >
            <img
              v-if="book.cover"
              :src="book.cover"
              class="rounded-top cImg"
              alt="..."
            />
            <img
              v-else
              class="rounded-top cImg"
              src="../assets/img/default.jpg"
            />
            <ul class="list-unstyled">
              <li>
                <a class="bd-content-title text-dark">{{ book.title }} </a>
              </li>
              <li class="text-secondary">{{ book.editor }}</li>
              <li class="text-secondary">{{ book.author }}</li>
            </ul>
          </router-link>
        </div>
      </div>
      <img
        src="../assets/img/banner.jpg"
        class="img-fluid mx-auto d-block banner"
        alt="Responsive image"
      />
    </div>
    <!-- 电子书 -->
    <div class="container" v-if="this.activeIndex === 4">
      <!-- Example row of columns -->
      <div class="row">
        <div
          class="col-lg-3 col-md-4 col-sm-6 col-6 cList pl-4 pr-4"
          v-for="e in ebook"
          :key="e.id"
        >
          <a>
            <div class="mt-3 mb-3 ml-1 mr-1">
              <img :src="e.cover" class="rounded-top cImg" alt="..." />
              <ul class="list-unstyled">
                <li class="mb-2">
                  <a class="bd-content-title text-dark">{{ e.title }}</a>
                </li>
                <a
                  :href="e.urls[0] == '无' ? '/#/noResource' : e.urls[0]"
                  target="_blank"
                  style="margin-right:10px;"
                >
                  <el-button type="success" plain size="mini">试读</el-button>
                </a>
                <a
                  :href="e.urls[1] == '无' ? '/#/noResource' : e.urls[1]"
                  target="_blank"
                >
                  <el-button type="info" plain size="mini">购买 </el-button>
                </a>
              </ul>
            </div>
          </a>
        </div>
      </div>
      <img
        src="../assets/img/banner.jpg"
        class="img-fluid mx-auto d-block banner"
        alt="Responsive image"
      />
    </div>

    <Bottom></Bottom>
  </div>
</template>

<script>
import {
  getBooks,
  getResources,
  getResourceDetail,
  getProtectContent,
} from "../api";
import headerIndex from "../components/headerIndex";
import Bottom from "../components/bottom";
const sanitizeHtml = require("sanitize-html");
export default {
  data() {
    return {
      Tagtext: [
        "国际范式与研究方法",
        "学术前沿与经典理论",
        "选题与科研立项",
        "学术写作与出版",
      ],
      activeIndex: 0,
      books: [],
      slide: [],
      ebook: [],
    };
  },
  components: {
    headerIndex,
    Bottom,
  },
  created() {
    console.log(this.$route.query.active)
    if (!this.$route.query.active) {
      this.activeIndex = 0;
      this.init();
    } else {
      this.activeIndex = Number(this.$route.query.active);
      if (this.$route.query.active < 4) {
        this.init();
      } else {
        // 电子书
        this.initEbook();
      }
    }
    // console.log(this.activeIndex);
    getResources("PK77WRCVG", { sort: "seq" }).then((data) => {
      if (data.success) {
        data.rows.forEach((s, index) => {
          // console.log(s.title);
          this.slide.push({ title: s.title, url: this.getUrls(s.desc) });
          getProtectContent("PK77WRCVG", s._id).then((data) => {
            // this.slide.push(data.data.download);
            this.$set(this.slide[index], "cover", data.data.download);
          });
          // console.log(this.slide);
        });
      }
    });
  },

  methods: {
    init() {
      console.log('init')
      getBooks({ tags: this.Tagtext[this.activeIndex] }).then((data) => {
        this.books = data.rows;
        data.rows.forEach((b, index) => {
          getResources(b._id, { chapter: "07" }).then((data) => {
            if (data.rows.length !== 0) {
              // console.log(data.rows[0].qiniuFileMeta.coverUrl);
              // this.cover[index] = data.rows[0].qiniuFileMeta.coverUrl;
              // this.books[index].cover = data.rows[0].qiniuFileMeta.coverUrl;
              this.$set(
                this.books[index],
                "cover",
                data.rows[0].qiniuFileMeta.coverUrl
              );
            }
          });
        });
        // console.log(this.books);
      });
    },
    handleChangeIndex(param) {
      this.activeIndex = param
      if (param < 4) this.init();
      else this.initEbook();
    },
    initEbook() {
      console.log('initEbook')
      getResources("FKLGQWVUG", { chapter: "11" }).then((data) => {
        console.log(data)
        if (data.success && data.rows[0]) {
          let arr = [];
          data.rows.forEach((c, index) => {
            arr.push({
              id: c.id,
              title: c.title,
              cover: c.qiniuFileMeta.coverUrl,
              urls: this.getUrls(c.desc).split("||"),
            });
          });
          this.ebook = arr;
        }
      });
    },
    handleClick(index) {
      this.activeIndex = index;
      if (this.activeIndex < 4) this.init();
      else this.initEbook();
      // getBooks({ tags: this.Tagtext[index] }).then((data) => {
      //   this.books = data.rows;
      // });
    },
    getUrls(dirty) {
      let desc = sanitizeHtml(dirty, {
        allowedTags: [],
        allowedAttributes: {},
      });
      // let arr = desc.split("||");
      return desc;
    },
  },
};
</script>

<style>
@import url("../assets/bootstrap.css");
@import url("../assets/style.css");
</style>
<style type="text/css">
.col {
  padding: 0;
}
</style>
